//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- FUNÇÃO ASSÍNCRONA SALVAR EMPRESA ---------------//
// Responsável por salvar a empresa criada via API
export default async function updateCompanyService (id, formData) {
  try {
    await api.put(`/empresas/${id}`, formData);
    toast.success("Empresa atualizada com sucesso!");
    return true;
  } catch (error) {
    toast.error("Erro ao atualizar empresa!");
    return false;
  }
}